import React from "react";
import '../css/Booking.css'; // Import the CSS for styling


const Booking = () => {
 const cabs = [
  {
    id: 1,
    name: "Hatchback - Maruti Celerio",
    seats: "4+1",
    local: "₹2500",
    perKm: "₹13",
    extraHr: "₹150",
    driverAllowance: "₹400",
    nightHalt: "₹250",
    pickupDrop: "₹3000",
    outstation: "₹3900",
    distance: "300km",
    image: "/images/booking/1.jpg"
  },
  {
    id: 2,
    name: "Hatchback- Maruti WagonR",
    seats: "4+1",
    local: "₹2600",
    perKm: "₹14",
    extraHr: "₹180",
    driverAllowance: "₹400",
    nightHalt: "₹250",
    pickupDrop: "₹3100",
    outstation: "₹4000",
    distance: "300km",
    image: "/images/booking/2.jpg"
  },
  {
    id: 3,
    name: "Luxury Sedan - BMW",
    seats: "4+1",
    local: "₹2800",
    perKm: "₹14",
    extraHr: "₹200",
    driverAllowance: "₹450",
    nightHalt: "₹300",
    pickupDrop: "₹3300",
    outstation: "₹4200",
    distance: "300km",
    image: "/images/booking/3.jpg"
  },
  {
    id: 4,
    name: "Luxury Sedan - Mercedes C Class",
    seats: "4+1",
    local: "₹3200",
    perKm: "₹16",
    extraHr: "₹250",
    driverAllowance: "₹500",
    nightHalt: "₹350",
    pickupDrop: "₹3700",
    outstation: "₹4700",
    distance: "300km",
    image: "/images/booking/4.jpg"
  },
  {
    id: 5,
    name: "SUV Premium - Toyota Innova Crysta",
    seats: "6+1",
    local: "₹4500",
    perKm: "₹20",
    extraHr: "₹300",
    driverAllowance: "₹600",
    nightHalt: "₹500",
    pickupDrop: "₹5500",
    outstation: "₹7500",
    distance: "300km",
    image: "/images/booking/5.jpg"
  },
  {
    id: 6,
    name: "Luxury Sedan - Mercedes E Class",
    seats: "4+1",
    local: "₹5000",
    perKm: "₹22",
    extraHr: "₹350",
    driverAllowance: "₹600",
    nightHalt: "₹500",
    pickupDrop: "₹6000",
    outstation: "₹8000",
    distance: "300km",
    image: "/images/booking/6.jpg"
  },
  {
    id: 7,
    name: "SUV Luxury - Toyota Fortuner",
    seats: "6+1",
    local: "₹5500",
    perKm: "₹24",
    extraHr: "₹400",
    driverAllowance: "₹700",
    nightHalt: "₹600",
    pickupDrop: "₹6500",
    outstation: "₹9000",
    distance: "300km",
    image: "/images/booking/7.jpg"
  },
  {
    id: 8,
    name: "SUV Luxury - Mercedes GLS",
    seats: "6+1",
    local: "₹6500",
    perKm: "₹28",
    extraHr: "₹450",
    driverAllowance: "₹800",
    nightHalt: "₹700",
    pickupDrop: "₹7500",
    outstation: "₹10000",
    distance: "300km",
    image: "/images/booking/8.jpg"
  },
  {
    id: 9,
    name: "Luxury Sedan - Mercedes S Class",
    seats: "4+1",
    local: "₹7000",
    perKm: "₹30",
    extraHr: "₹500",
    driverAllowance: "₹900",
    nightHalt: "₹750",
    pickupDrop: "₹8000",
    outstation: "₹11000",
    distance: "300km",
    image: "/images/booking/9.jpg"
  },
  {
    id: 10,
    name: "SUV - Toyota Innova",
    seats: "6+1",
    local: "₹7500",
    perKm: "₹32",
    extraHr: "₹550",
    driverAllowance: "₹1000",
    nightHalt: "₹800",
    pickupDrop: "₹8500",
    outstation: "₹12000",
    distance: "300km",
    image: "/images/booking/10.jpg"
  },
  {
    id: 11,
    name: "SUV - Mahindra Marrazzo",
    seats: "6+1",
    local: "₹5000",
    perKm: "₹25",
    extraHr: "₹350",
    driverAllowance: "₹700",
    nightHalt: "₹600",
    pickupDrop: "₹6000",
    outstation: "₹8500",
    distance: "300km",
    image: "/images/booking/11.jpg"
  },
  {
    id: 12,
    name: "Sedan - Toyota Etios",
    seats: "4+1",
    local: "₹8500",
    perKm: "₹38",
    extraHr: "₹600",
    driverAllowance: "₹1200",
    nightHalt: "₹900",
    pickupDrop: "₹9500",
    outstation: "₹13000",
    distance: "300km",
    image: "/images/booking/12.jpg"
  },
  {
    id: 13,
    name: "Sedan - Maruti Dzire",
    seats: "4+1",
    local: "₹8500",
    perKm: "₹38",
    extraHr: "₹600",
    driverAllowance: "₹1200",
    nightHalt: "₹900",
    pickupDrop: "₹9500",
    outstation: "₹13000",
    distance: "300km",
    image: "/images/booking/13.jpg"
  },
  {
    id: 14,
    name: "Sedan - Hyundai Xcent",
    seats: "4+1",
    local: "₹8500",
    perKm: "₹38",
    extraHr: "₹600",
    driverAllowance: "₹1200",
    nightHalt: "₹900",
    pickupDrop: "₹9500",
    outstation: "₹13000",
    distance: "300km",
    image: "/images/booking/14.jpg"
  },
  {
    id: 15,
    name: "Premium Sedan - Maruti Ciaz",
    seats: "4+1",
    local: "₹8500",
    perKm: "₹38",
    extraHr: "₹600",
    driverAllowance: "₹1200",
    nightHalt: "₹900",
    pickupDrop: "₹9500",
    outstation: "₹13000",
    distance: "300km",
    image: "/images/booking/15.jpg"
  },
  {
    id: 16,
    name: "Luxury Sedan - Toyota Camry",
    seats: "4+1",
    local: "₹8500",
    perKm: "₹38",
    extraHr: "₹600",
    driverAllowance: "₹1200",
    nightHalt: "₹900",
    pickupDrop: "₹9500",
    outstation: "₹13000",
    distance: "300km",
    image: "/images/booking/16.jpg"
  },
  {
    id: 17,
    name: "Mini Bus or Tempo traveller 13 to 27 seater",
    seats: "13 to 27 Seater",
    local: "₹8500",
    perKm: "₹38",
    extraHr: "₹600",
    driverAllowance: "₹1200",
    nightHalt: "₹900",
    pickupDrop: "₹9500",
    outstation: "₹13000",
    distance: "300km",
    image: "/images/booking/17.jpg"
  },
  {
    id: 18,
    name: "MUV - Mahindra Xylo",
    seats: "6+1",
    local: "₹8500",
    perKm: "₹38",
    extraHr: "₹600",
    driverAllowance: "₹1200",
    nightHalt: "₹900",
    pickupDrop: "₹9500",
    outstation: "₹13000",
    distance: "300km",
    image: "/images/booking/18.jpg"
  },
  {
    id: 19,
    name: "MUV - Maruti Ertiga",
    seats: "6+1",
    local: "₹8500",
    perKm: "₹38",
    extraHr: "₹600",
    driverAllowance: "₹1200",
    nightHalt: "₹900",
    pickupDrop: "₹9500",
    outstation: "₹13000",
    distance: "300km",
    image: "/images/booking/19.jpg"
  },
  {
    id: 20,
    name: "Premium Sedan - Honda Amaze",
    seats: "4+1",
    local: "₹8500",
    perKm: "₹38",
    extraHr: "₹600",
    driverAllowance: "₹1200",
    nightHalt: "₹900",
    pickupDrop: "₹9500",
    outstation: "₹13000",
    distance: "300km",
    image: "/images/booking/20.jpg"
  },
  {
    id: 21,
    name: "Premium Sedan - Honda City",
    seats: "4+1",
    local: "₹8500",
    perKm: "₹38",
    extraHr: "₹600",
    driverAllowance: "₹1200",
    nightHalt: "₹900",
    pickupDrop: "₹9500",
    outstation: "₹13000",
    distance: "300km",
    image: "/images/booking/21.jpg"
  },
  {
    id: 22,
    name: "Premium Sedan - Toyota Corolla",
    seats: "4+1",
    local: "₹8500",
    perKm: "₹38",
    extraHr: "₹600",
    driverAllowance: "₹1200",
    nightHalt: "₹900",
    pickupDrop: "₹9500",
    outstation: "₹13000",
    distance: "300km",
    image: "/images/booking/22.jpg"
  },
  {
    id: 23,
    name: "Bus 30 Seater",
    seats: "30+1",
    local: "₹8500",
    perKm: "₹38",
    extraHr: "₹600",
    driverAllowance: "₹1200",
    nightHalt: "₹900",
    pickupDrop: "₹9500",
    outstation: "₹13000",
    distance: "300km",
    image: "/images/booking/23.jpg"
  },
  {
    id: 24,
    name: "Bus 35 Seater",
    seats: "35+1",
    local: "₹8500",
    perKm: "₹38",
    extraHr: "₹600",
    driverAllowance: "₹1200",
    nightHalt: "₹900",
    pickupDrop: "₹9500",
    outstation: "₹13000",
    distance: "300km",
    image: "/images/booking/24.jpg"
  }
];

 




  const handleBookingClick = (cabName) => {
    const message = `I want to book ${cabName}`;
    const whatsappUrl = `https://wa.me/919075462128?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  };

  return (
    <div className="pb-5">
    
<section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>Booking</h1>
                    </div>
                </div>
            </section>



  

  

      <section id="about" className="jarallax text-light">
        <div className="center-y relative text-center">
          <div className="container">
            <div className="row">
              <div className="col-md-12 text-center pt-5">
                {/* <h1 className='text-white'>Booking</h1> */}
              </div>
              <div className="clearfix"></div>
            </div>
          </div>
        </div>
      </section>

      <div className="container d-flex justify-content-center align-items-center py-5 bg-dark ">
        <div className="row w-100 ">
          {cabs.map((cab) => (
            <div key={cab.id} className="col-12 mb-4 d-flex justify-content-center ">
              <div className="row booking-card">
                <div className="col-md-4 d-flex align-items-center justify-content-center">
                  <img src={cab.image} alt={cab.name} className="booking-image img-fluid" />
                </div>
                <div className="col-md-4 d-flex flex-column justify-content-center ">
                  <h3 className="darkcolor">{cab.name}</h3>
                  <p className="text-white">Seater: {cab.seats}</p>
                  <p className="text-white">Local: {cab.local}</p>
                  <p className="text-white">Mumbai Pickup & Drop: {cab.pickupDrop}</p>
                  <p className="text-white">Outstation ({cab.distance}): {cab.outstation}</p>
                </div>
                <div className="col-md-4 d-flex flex-column justify-content-center pricing-details">
                  <p className="text-white">Extra Hr: {cab.extraHr}</p>
                  <p className="text-white">Driver Allowance: {cab.driverAllowance}</p>
                  <p className="text-white">Night Halt: {cab.nightHalt}</p>
                  <button onClick={() => handleBookingClick(cab.name)} className="book-now-btn mt-3">
                    Book Now
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Booking;
